import { render, staticRenderFns } from "./VideoCallGrid.vue?vue&type=template&id=7408b864&"
import script from "./VideoCallGrid.vue?vue&type=script&lang=js&"
export * from "./VideoCallGrid.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallGrid.vue?vue&type=style&index=0&id=7408b864&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports